import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Login from "./pages/Login";
import Contact from "./pages/Contact";
import Menu from "./pages/Menu";
import Wishlist from "./pages/Wishlist";
import Authenticated from "./pages/Authenticated";
import Cart from "./pages/Cart";
import Profile from "./pages/Profile";
import ProtectedRoute from "./Components/ProtectedRoute";
import AuthRoute from "./Components/AuthRoute";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "login",
    element: <Login />,
  },
  {
    path: "contact",
    element: <ProtectedRoute Component={Contact} />,
  },
  {
    path: "menu",
    element: <ProtectedRoute Component={Menu} />,
  },
  {
    path: "wishlist",
    element: <ProtectedRoute Component={Wishlist} />,
  },
  {
    path: "auth-success",
    element: <AuthRoute Component={Authenticated} />,
  },
  {
    path: "cart",
    element: <ProtectedRoute Component={Cart} />,
  },
  {
    path: "profile",
    element: <ProtectedRoute Component={Profile} />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
